module.exports = __webpack_public_path__ + "img/introduce-3.6fd6ed6d.png";